/* Single source of truth for FAQ copy, shared by the full /faq page and
   the three-question subset kept inline on Landing before the final CTA.
   Keep index.html's FAQPage JSON-LD in sync by hand whenever this changes
   — it's static markup, not generated from this file. */
export const FAQ_DATA = [
  {
    id: 'live-now',
    q: "What's live right now?",
    a: 'AI Prompt Engineering is live end-to-end. Copywriting, Sales & Negotiation and Precision Storytelling are in survey — real, scored content, still being finished. Technical Translation is planned: no curriculum exists for it yet.',
  },
  {
    id: 'tutorial',
    q: 'Is this just another AI tutorial?',
    a: "No. Tutorials make you a passenger. Here you write, a number comes back with the reason behind it, and you go again until you can produce the thing on demand.",
  },
  {
    id: 'who',
    q: 'Who is this for?',
    a: 'Anyone who uses AI or plain communication to get work done: marketers, founders, developers, sales reps, ops leads. If you keep rewriting the same prompt, or losing deals you should be closing, this is the fix.',
  },
  {
    id: 'what-is-a-rep',
    q: 'What is a rep?',
    a: 'One scored exercise. You read a brief, write your response, and it comes back scored 0 to 100 with the criteria it passed and failed. About 45 seconds.',
  },
  {
    id: 'why-free',
    q: 'Why is it free to start?',
    a: "Because we're building a standard, not selling a course. One scoring engine runs every skill, so letting you test it costs us very little and tells you everything. No card.",
  },
];

/* The three read at the moment of decision — kept inline on Landing. */
export const LANDING_INLINE_FAQ_IDS = ['live-now', 'what-is-a-rep', 'why-free'];
